import { render, staticRenderFns } from "./ButtonFullRectangonal.vue?vue&type=template&id=615fca61&scoped=true&"
import script from "./ButtonFullRectangonal.vue?vue&type=script&lang=js&"
export * from "./ButtonFullRectangonal.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFullRectangonal.vue?vue&type=style&index=0&id=615fca61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615fca61",
  null
  
)

export default component.exports